import React from "react";
import {
  UShortCode
} from "../../_metronic/_partials";

export function UpdateShortCode(props) {
  return <UShortCode {...props} />;
}
